import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  warehouse: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
  warehouse: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
};

export const { actions: organizationActions, reducer: organizationReducer } = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    //Request
    setOrganizationRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setOrganizationRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setOrganizationRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setOrganizationRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    //List
    setOrganizationListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setOrganizationListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setOrganizationListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setOrganizationListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
    //One
    setOrganizationOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setOrganizationOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setOrganizationOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setOrganizationOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
    //Warehouse
    setOrganizationWarehouseRequest: (state) => {
      state.warehouse = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setOrganizationWarehouseSuccess: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setOrganizationWarehouseFailure: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setOrganizationWarehouseDefault: (state) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
  },
});
